module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "album-list-container"
  }, [_vm._v("\n    专辑列表页\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-9339d498"}!./~/._vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Album/index.vue
// module id = 164
// module chunks = 1